<template>
  <div class="table">
    <div
      ref="caozuo"
      style="display: flex; justify-content: space-between; margin-bottom: 10px"
    >
      <div>
        <el-button size="small" plain @click="shuaxin">
          <i class="el-icon-refresh-right"></i> 刷新
        </el-button>
        <!-- <ExportExcel
          :E_ids="E_ids"
          :E_condition="E_condition"
          :E_dataLength="E_dataLength"
          :E_methodname="E_methodname"
          :E_searchArr="E_searchArr"
        ></ExportExcel> -->
      </div>
      <!-- //搜索 -->
      <el-form :model="formes" :inline="true" label-width="90px">
        <el-form-item label style="margin-bottom: 0">
          <el-date-picker
            v-model="value2"
            size="small"
            type="daterange"
            align="right"
            value-format="yyyy-MM-dd"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            style="width: 300px"
            @change="timeget"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label style="margin-bottom: 0">
          <el-select
            v-model="select"
            placeholder="请选择"
            @change="switchover2"
            size="small"
            class="especially"
            style="width: 110px"
          >
            <el-option label="代理商" :value="1"></el-option>
            <el-option label="授权对象" :value="2"></el-option>
            <!-- <el-option label="类型" :value="3"></el-option> -->
            <el-option label="授权商品" :value="4"></el-option>
          </el-select>
          <!-- 关键字 -->
          <el-select
            v-if="select == 1"
            v-model="formes.keywords"
            filterable
            class="especially2"
            placeholder="请选择代理商"
            style="width: 190px"
            size="small"
            @change="inputsearch"
            clearable
          >
            <el-option
              v-for="item in agentData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            v-else-if="select == 3"
            v-model="formes.keywords"
            filterable
            class="especially2"
            placeholder="请选择"
            style="width: 190px"
            size="small"
            @change="inputsearch"
            clearable
          >
            <el-option label="充值" :value="1"></el-option>
            <el-option label="扣款" :value="2"></el-option>
          </el-select>
          <el-select
            v-else-if="select == 4"
            v-model="formes.keywords"
            filterable
            class="especially2"
            placeholder="请输入授权商品名称"
            style="width: 190px"
            size="small"
            @change="inputsearch"
            clearable
          >
            <el-option
              v-for="item in callTypeList"
              :key="item.call_type_id"
              :label="item.callTypeInfo.card"
              :value="item.call_type_id"
            ></el-option>
          </el-select>
          <el-input
            v-else
            @input="inputsearch"
            size="small"
            placeholder="请输入"
            v-model="formes.keywords"
            class="especially2"
            style="width: 190px"
          >
            <i slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      :height="zhanshi"
      :data="tableData"
      style="width: 100%"
      :header-cell-style="headerCellStyle"
      :cell-style="cellStyle"
      @selection-change="handleSelectionChange"
      ref="multipleTable"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column label="授权操作人">
        <template slot-scope="scope">
          {{ scope.row.fromUserInfo.name }}
        </template>
      </el-table-column>
      <el-table-column label="授权对象">
        <template slot-scope="scope">
          {{ scope.row.toUserInfo.name }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.types == 1" class="success">充值</span>
          <span v-else class="warning">扣款</span>
        </template>
      </el-table-column> -->
      <el-table-column label="授权商品">
        <template slot-scope="scope">
          {{ scope.row.callTypeInfo.card }}
        </template>
      </el-table-column>
      <el-table-column prop="end_time" label="授权到期时间"> </el-table-column>
      <el-table-column prop="created_at" label="授权时间"></el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      class="pagination_bottom"
      background
      layout="total,sizes, prev, pager, next"
      :page-sizes="[20, 50, 100, 200, 300, 400]"
      @size-change="handleSizeChange"
      :total="total"
      :page-size="pagesize"
      @current-change="current_change"
      :current-page="currentPage"
    ></el-pagination>
  </div>
</template>

<script>
import { postData, getData } from "@/api/index";
import { debounce } from "@/utils/tool.js";
import ExportExcel from "@/components/ExportExcel";
export default {
  components: {
    ExportExcel,
  },
  data() {
    return {
      E_ids: [], //选中id
      E_condition: {}, //条件
      E_dataLength: 0, //数据长度
      E_searchArr: ["from_name", "to_name", "type", "call_type_id"], //搜索条件过滤
      E_methodname: "authorization_record", //方法名
      zhanshi: "800px",
      select: 1,
      tableData: [],
      callTypeList: [],
      total: 0, //默认数据总数
      pagesize: 20, //每页的数据条数
      currentPage: 1, //默认开始页面
      //搜索
      formes: {
        stime: "",
        etime: "",
        keywords: "",
      },
      agentData: [],
      value2: [],
      // 时间搜索
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  created() {
    this.getMainData({
      pagesize: 20,
      page: 1,
    });
    this.getAgentData();
    this.getCallTypeList();
  },
  mounted() {
    setTimeout(() => {
      var caozuo = this.$refs.caozuo.offsetHeight;
      var H = document.body.clientHeight;
      this.zhanshi = H - caozuo - 60 - 38 - 28 - 50 - 10;
    }, 100);
    const that = this;
    window.onresize = () => {
      var caozuo = this.$refs.caozuo.offsetHeight;
      var H = document.body.clientHeight;
      that.zhanshi = H - caozuo - 60 - 38 - 28 - 50 - 10;
    };
  },
  methods: {
    timeget(val) {
      if (val) {
        this.formes.stime = val[0] + " 00:00:00";
        this.formes.etime = val[1] + " 23:59:59";
      } else {
        this.formes.stime = "";
        this.formes.etime = "";
      }
      this.searchArr(1);
    },
    getAgentData() {
      getData("UserController/pageAction", {
        pagesize: 10000,
        page: 1,
        role: 2,
      }).then((res) => {
        this.agentData = res.data.data;
      });
    },
    getCallTypeList() {
      getData("call.CallSeatController/listAction").then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        this.callTypeList = res.data;
      });
    },
    handleSelectionChange(val) {
      this.E_ids = [];
      val.forEach((i) => {
        this.E_ids.push(i.id);
      });
    },
    inputsearch: debounce(function(e) {
      this.searchArr(1);
    }),
    switchover2() {
      this.formes = {
        keywords: "",
      };
      if (this.select == 1) this.getAgentData();
      this.searchArr(1);
    },
    searchArr(flag) {
      if (flag) {
        this.currentPage = 1;
        this.pagesize = 20;
      }
      let params = {
        pagesize: this.pagesize,
        page: this.currentPage,
      };
      if (this.formes.etime) {
        params.stime = this.formes.stime;
        params.etime = this.formes.etime;
      }
      if (this.formes.keywords) {
        switch (this.select) {
          case 1:
            params.from = this.formes.keywords;
            break;
          case 2:
            params.to_name = this.formes.keywords;
            break;
          case 3:
            params.type = this.formes.keywords;
            break;
          case 4:
            params.call_type_id = this.formes.keywords;
            break;
        }
      }
      this.getMainData(params);
    },
    //刷新
    shuaxin() {
      this.currentPage = 1;
      this.pagesize = 20;
      this.value2 = [];
      this.select = 1;
      this.formes = {
        keywords: "",
        stime: "",
        etime: "",
      };
      this.searchArr(1);
      this.$message({ message: "刷新成功", type: "success" });
    },
    headerCellStyle() {
      return "text-align:center;background-color:#F2f2f2;";
    },
    cellStyle() {
      return "text-align:center;";
    },
    // 获取数据
    getMainData(params) {
      this.E_condition = params;
      getData("call.CallSeatLogController/pageAction", params).then((res) => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.E_dataLength = res.data.total;
        this.currentPage = res.data.current_page;
        this.pagesize = res.data.per_page;
      });
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.searchArr();
    },
    // 分页
    current_change: function(currentPage) {
      this.currentPage = currentPage;
      this.searchArr();
    },
  },
};
</script>

<style lang="less" scoped>
.el-tabs--border-card {
  border: 0;
  box-shadow: none;
}
.avatar-uploader {
  display: none;
}
.content {
  height: 300px;
  overflow: hidden;
  /deep/img {
    width: 360px;
  }
}
.content:hover {
  overflow-y: overlay;
}
::-webkit-scrollbar {
  width: 0px !important;
  height: 0px !important;
  // width: 18px !important;
}
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgb(182, 182, 182);
  border: 7px solid transparent;
}
::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0);
}
</style>
<style scoped>
.warning {
  color: #f56c6c;
}
.success {
  color: #46c160;
}
</style>
<style lang="less" src="@/assets/css/especially.less" scoped></style>
<style src="@/assets/css/index.css" scoped></style>
